<template>
    <div>
        <h3>Signin Sample</h3>
        <form @submit.prevent="onSubmitSignin">
            <input v-model="signinInfo.id" placeholder="아이디">
            <input v-model="signinInfo.password" placeholder="비밀번호">
            <button type="submit">signin</button>
        </form>

        <h3>Signout Sample</h3>
        <button @click="onClickSignout">signout</button>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import * as jwtUtil from '@/utils/jwtUtil'

export default {
    name: 'SigninSample',
    data() {
        return {
            signinInfo:{
                id: '',
                password: ''
            }
        }
    },
    computed: {
      ...mapGetters('auth',[
        'getUser',
      ])
    },
    methods:{
    ...mapActions('auth', [
      'signin',
      'signout'
    ]),
    onSubmitSignin(){
      this.signin(this.signinInfo)
      .then(() => {
        alert("로그인 성공")
      })
      .catch(() => {
        alert("로그인 실패")
      })
    },
    onClickSignout(){
      var refreshToken = localStorage.getItem(jwtUtil.LOCAL_STORAGE_KEY_REFRESH_TOKEN)
      var user = this.getUser
    
      if(!(refreshToken == null || user == null)){
        this.signout({
          userIdx: user.idx, 
          refreshToken: refreshToken
        })
        .then(() => {
          alert("로그아웃 성공")
        })
        .catch(() => {
          alert("로그아웃 실패")
        })
      }
      else{
        alert("로그인 정보가 없습니다.")
      }
    }
  }
}
</script>